import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const features = [
  {
    title: "Skilled Technical Team",
    description: "Our HVAC specialists are trained to maintain and service a wide range of cooling systems with precision and efficiency.",
    icon: "Users"
  },
  {
    title: "Preventive Service Approach",
    description: "We focus on proactive maintenance that reduces system failures and improves operational reliability.",
    icon: "Shield"
  },
  {
    title: "Energy Efficiency Optimization",
    description: "Properly maintained systems consume less energy, helping reduce operational costs.",
    icon: "Zap"
  },
  {
    title: "Fast Technical Support",
    description: "Our service team responds quickly to maintenance requests and urgent repairs.",
    icon: "Clock"
  }
];

const WhyChooseAC = () => {
  return (
    <section className="py-24 bg-slate-50 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Why Choose VASTECH</h2>
            <h3 className="text-5xl font-bold text-[#4D4C4A] leading-tight mb-12 italic tracking-tighter">
              Commitment to <span className="text-[#91756A]">Climate</span> Excellence.
            </h3>
            
            <div className="grid sm:grid-cols-2 gap-x-12 gap-y-16">
              {features.map((feature, index) => (
                <motion.div 
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                >
                  <div className="flex items-center space-x-4 mb-4">
                    <Icon name={feature.icon} size={20} className="text-[#91756A]" />
                    <h4 className="text-lg font-bold text-[#4D4C4A] tracking-tighter uppercase italic">{feature.title}</h4>
                  </div>
                  <p className="text-slate-500 text-sm leading-relaxed border-l-2 border-[#91756A]/20 pl-4 ml-2">
                    {feature.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="relative aspect-square lg:aspect-auto h-full min-h-[500px]"
          >
            <div className="absolute inset-0 overflow-hidden">
              <Image 
                src="/assets/images/AC-page/AC-1080px-by-1080px-6.jpg" 
                alt="VASTECH HVAC Excellence" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-[#4D4C4A]/80 backdrop-blur-sm px-8 py-6">
                  <h4 className="text-3xl md:text-4xl font-bold text-white italic tracking-tighter uppercase leading-tight text-center">
                    High Performance <br />
                    <span className="text-[#91756A]">HVAC</span> Engineering
                  </h4>
                  <div className="w-16 h-1 bg-[#91756A] mx-auto mt-6"></div>
                </div>
              </div>
            </div>
            
            <div className="absolute -top-6 -right-6 w-full h-full border-2 border-[#91756A]/20 -z-10 pointer-events-none"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseAC;